import React from "react"
import { Grid, TextField, Autocomplete, Typography, InputAdornment } from "@mui/material"

const TabTarjetaCredito = ({ pago, handleInputChange, cat }) => {
  // Handler para asegurar que solo se ingresen números en campos que lo requieran
  const handleNumericInput = (field, value, maxLength) => {
    const onlyNums = value.replace(/[^0-9]/g, "")
    if (onlyNums.length <= maxLength) {
      handleInputChange(field, onlyNums)
    }
  }

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="subtitle2" color="primary" sx={{ mb: -1 }}>
          Detalle de Transacción con Tarjeta
        </Typography>
      </Grid>

      {/* 1. Selección de Tarjeta (Crédito / Débito) */}
      <Grid item xs={12} md={6}>
        <Autocomplete
          options={cat.tarjetas || []}
          getOptionLabel={(option) => option.label || ""}
          value={(cat.tarjetas || []).find((t) => t.id === pago.banco_tarjeta) || null}
          onChange={(e, nv) => handleInputChange("banco_tarjeta", nv ? nv.id : "")}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => <TextField {...params} label="Tarjeta *" size="small" />}
        />
      </Grid>

      {/* 2. Selección de Adquiriente */}
      <Grid item xs={12} md={6}>
        <Autocomplete
          options={cat.adquirientes || []}
          getOptionLabel={(option) => option.label || ""}
          value={(cat.adquirientes || []).find((a) => a.id === pago.adquiriente) || null}
          onChange={(e, nv) => handleInputChange("adquiriente", nv ? nv.id : "")}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          renderInput={(params) => <TextField {...params} label="Adquiriente (Opcional)" size="small" />}
        />
      </Grid>

      {/* 3. Número de Lote */}
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Nº Lote *"
          size="small"
          placeholder="Ej. 123"
          value={pago.lote || ""}
          onChange={(e) => handleNumericInput("lote", e.target.value, 10)}
        />
      </Grid>

      {/* 4. Número de Autorización */}
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Nº Autorización *"
          size="small"
          value={pago.autorizacion || ""}
          onChange={(e) => handleNumericInput("autorizacion", e.target.value, 15)}
        />
      </Grid>

      {/* 5. Número de Voucher */}
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Voucher *"
          size="small"
          value={pago.cheque_transf || ""}
          onChange={(e) => handleNumericInput("cheque_transf", e.target.value, 20)}
        />
      </Grid>

      {/* 6. Propina (Regla de negocio VB6) */}
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Propina (Opcional)"
          size="small"
          type="number"
          value={pago.propina || ""}
          onChange={(e) => handleInputChange("propina", e.target.value)}
          inputProps={{ min: 0, step: "0.01" }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          helperText="No se suma al abono de la deuda"
        />
      </Grid>
    </>
  )
}

export default TabTarjetaCredito
